export enum JOB_SCHEDULE_ACTION {
    EDIT = 'schedule-edit',
    DUPLICATE = 'schedule-duplicate',
    ENABLE = 'schedule-enable',
    DISABLE = 'schedule-disable',
    DESTROY = 'schedule-destroy',
    ALARMS_SILENCE = 'schedule-alarm-silence',
    ALARMS_UNSILENCE = 'schedule-alarm-enable',
}
